import React from 'react';

/** Sunrise / warm morning — sun on horizon */
export function MorningTimeIcon({ className, ...props }) {
  const raw = React.useId().replace(/:/g, '');
  const gradId = `tp-mg-${raw}`;
  const clipId = `tp-mc-${raw}`;
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <defs>
        <linearGradient id={gradId} x1="12" y1="6" x2="12" y2="20" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fde047" />
          <stop offset="0.55" stopColor="#fbbf24" />
          <stop offset="1" stopColor="#f97316" />
        </linearGradient>
        <clipPath id={clipId}>
          <rect x="0" y="0" width="24" height="16.5" />
        </clipPath>
      </defs>
      <path d="M2 17h20" stroke="#fb923c" strokeWidth="1.4" strokeLinecap="round" opacity="0.85" />
      <circle cx="12" cy="14" r="5.75" fill={`url(#${gradId})`} clipPath={`url(#${clipId})`} />
      <path
        d="M6 8c1.2-0.6 2.5-0.9 3.8-0.9"
        stroke="#93c5fd"
        strokeWidth="1.2"
        strokeLinecap="round"
        opacity="0.85"
      />
    </svg>
  );
}

/** Midday sun with rays */
export function AfternoonTimeIcon({ className, ...props }) {
  const raw = React.useId().replace(/:/g, '');
  const gradId = `tp-ag-${raw}`;
  const rays = [0, 45, 90, 135, 180, 225, 270, 315];
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <defs>
        <radialGradient
          id={gradId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12 12) rotate(90) scale(5)"
        >
          <stop stopColor="#fef08a" />
          <stop offset="1" stopColor="#eab308" />
        </radialGradient>
      </defs>
      {rays.map((deg) => {
        const r = (deg * Math.PI) / 180;
        const c = Math.cos(r);
        const s = Math.sin(r);
        return (
          <line
            key={deg}
            x1={12 + c * 6.2}
            y1={12 + s * 6.2}
            x2={12 + c * 9.4}
            y2={12 + s * 9.4}
            stroke="#facc15"
            strokeWidth="1.35"
            strokeLinecap="round"
          />
        );
      })}
      <circle cx="12" cy="12" r="5" fill={`url(#${gradId})`} stroke="#ca8a04" strokeWidth="0.6" />
    </svg>
  );
}

/** Moon + stars — evening */
export function EveningTimeIcon({ className, ...props }) {
  const raw = React.useId().replace(/:/g, '');
  const moonGrad = `tp-eg-${raw}`;
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <defs>
        <linearGradient id={moonGrad} x1="14" y1="6" x2="8" y2="16" gradientUnits="userSpaceOnUse">
          <stop stopColor="#c7d2fe" />
          <stop offset="1" stopColor="#6366f1" />
        </linearGradient>
      </defs>
      <path
        d="M17.5 8.7a5.6 5.6 0 1 1-7.2 7 6.3 6.3 0 1 0 7.2-7z"
        fill={`url(#${moonGrad})`}
        stroke="#4f46e5"
        strokeWidth="0.35"
      />
      <circle cx="7" cy="6.5" r="0.9" fill="#fde047" opacity="0.95" />
      <circle cx="4.5" cy="11" r="0.55" fill="#e9d5ff" />
      <circle cx="9.5" cy="10.5" r="0.45" fill="#c4b5fd" opacity="0.9" />
    </svg>
  );
}

export const TIME_PART_ICON_BY_ID = {
  morning: MorningTimeIcon,
  afternoon: AfternoonTimeIcon,
  evening: EveningTimeIcon,
};
